import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import UploadDocument from 'modules/documents/components/UploadDocument';
import InputText from 'modules/_shared/components/InputText';
import { isPlatformAXA } from 'utils/showDetails';
import {
  TYPE_FILES_ALLOWED,
  TYPE_FILES_ALLOWED_UNSAFE,
} from 'constants/defaultConstants';
import { useUploadDocumentModal } from '../context/UploadDocumentModalContext';

const UploadDocumentModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useUploadDocumentModal();

  const fileTypesAllowed = isPlatformAXA
    ? `${TYPE_FILES_ALLOWED},${TYPE_FILES_ALLOWED_UNSAFE}`
    : TYPE_FILES_ALLOWED;

  return (
    <>
      <Modal.Body>
        <UploadDocument
          accept={fileTypesAllowed}
          label="Document"
          inputLabel={t('DragDocumentToUpload')}
          file={data.file}
          setFile={actions.handleChangeFile}
          includeFileSize
          mandatory
        />

        <div className="form-group">
          <InputText
            id="name"
            label={t('Name')}
            value={data.name}
            onChange={actions.handleChangeName}
            required
            lgSize
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="date">
            {t('Date')} <MandatoryField />
          </label>
          <div className="form-control-wrap">
            <input
              id="date"
              type="date"
              className="form-control form-control-lg"
              value={data.date}
              onChange={actions.handleChangeDate}
              max="2100-01-01"
              min="1000-01-01"
            />
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default UploadDocumentModalBody;
